import { IBuyGiftCardOld } from "../models/BuyGiftCard.model";
import { RecipientDetailsModel } from "../models/RecipientDetails.model";
import { IRecipientsStep } from "../models/RecipientsStep.model";
import { IRegiftCard } from "../models/RegiftCard.model";
import { IChooseRecipientsStepModel, RecipientDetailsModel as RecipientDetailsModelNew } from "../models/buy-giftcard/choose-card/ChooseRecipientsStep.model";
import ILink from "../models/core/Link.interface";

export function findLinkByAlias(alias: string, links: Array<ILink>): ILink | null {

    const link = links.find((el) => el.alias == alias);
    //console.debug('findLinkByAlias', links, alias, link);
    if(link) return link;

    return { alias: '', title: '', url: '', targetBlank: false } as ILink;
}

export function resetRecipientsCountOnRecipientStep(quantity: number, stepModel: IRecipientsStep | IChooseRecipientsStepModel): IRecipientsStep | IChooseRecipientsStepModel {
    if (quantity == 1) {
        stepModel.sendIndividually = false;
    } else if (quantity > 1) {
        stepModel.sendIndividually = true;
    }

    const recipientsCount = stepModel.recipients.length;
    let hasToAddRecipients = recipientsCount == 0; // if there are not yet recipients.

    // check if there are already some recipients records
    if (recipientsCount > 0) {
        if (quantity > recipientsCount) {
            hasToAddRecipients = true;
            quantity = quantity - recipientsCount; // remaining records
        } else if (quantity < recipientsCount) {
            hasToAddRecipients = false; // no need to add recipients, we need to remove
            let recordsToRemove = recipientsCount - quantity;
            if (recordsToRemove > 0) {
                let recipients = [...stepModel.recipients] as typeof stepModel.recipients;

                while (recordsToRemove > 0) {
                    recipients = recipients.slice(0, recipients.length - 1);
                    recordsToRemove = recordsToRemove - 1;
                }

                stepModel.recipients = recipients;
            }
        }
    }

    if (hasToAddRecipients) {
        for (let i = 0; i < quantity; i++) {
            if ("sender" in stepModel) {
                // the model type is the old one
                stepModel.recipients.push(new RecipientDetailsModel());
            } else {
                stepModel.recipients.push(new RecipientDetailsModelNew());
            }
        }
    }

    return stepModel;
}

export function isAnBuyGiftCard(obj: any): obj is IBuyGiftCardOld {
    //console.debug('isAnBuyGiftCard', obj, 'chooseCard' in obj);
    return 'chooseCard' in obj;
    //return 'type' in obj && obj.type === 'IBuyGiftCard';
}

export function isAnRegiftCard(obj: any): obj is IRegiftCard {
    return 'type' in obj && obj.type === 'IRegiftCard';
}

export function fixPreviewDetails() {

    setTimeout(() => {
        //hide image
        const previewImageEl = document.getElementById("cardDetailsDefaultTemplateId");
        if (previewImageEl) {
            //previewImageEl.style.opacity = "0";
            previewImageEl.style.display = "none";
        }
    }, 6000);

    
}
//export function validateRecepientsStep(viewModel: IRecipientsStep): boolean {
    
//    var model = RecipientsStepModel.parseModel(viewModel);
//    if (model) {
//        //console.debug('validateRecepientsStep', model.isValid());
//        return model.isValid()  ;
//    }

//    return false;
//}

